"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var RotateLeft = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M2,11.992017 L2,19.007983 C2,19.5498526 2.45127322,20 3.00276013,20 L11.9972399,20 C12.5540542,20 13,19.555968 13,19.007983 L13,11.992017 C13,11.4501474 12.5487268,11 11.9972399,11 L3.00276013,11 C2.44594575,11 2,11.444032 2,11.992017 Z M1,11.992017 C1,10.8918564 1.89354265,10 3.00276013,10 L11.9972399,10 C13.1033337,10 14,10.9001762 14,11.992017 L14,19.007983 C14,20.1081436 13.1064574,21 11.9972399,21 L3.00276013,21 C1.89666625,21 1,20.0998238 1,19.007983 L1,11.992017 Z M20.8418501,13.6 C20.425019,9.90965564 18.1155152,6.72160742 14.7773041,5.13927495 L14.6499082,5.07888848 L13.3616394,6.36715729 L10,3.00551794 C10.0736732,3.00181976 10.1424452,3 10.2116394,3 C16.2868088,3 21.3365556,7.6108387 21.9424111,13.6 L20.8418501,13.6 Z" })));
};
RotateLeft.displayName = 'RotateLeft';
exports.default = RotateLeft;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=RotateLeft.js.map